<form id="resource-header" #resourceform="ngForm">
    <ol *ngIf="sag">
        <li>
            <label class="col-form-label col-form-label-sm" for="timesats">Timesats</label>
            <ng-select id="timesats"
                       name="timetakst"
                       [disabled]="sag.locked"
                       required
                       class="ng-select-sm"
                       (change)="sagChange({timetakst: $event?.ts})"
                       [items]="timesatsNavne"
                       [ngModel]="sag.timetakst"
                       placeholder="Vælg timesats"
                       [multiple]="false"
                       [clearable]="false"
                       bindValue="ts"
                       bindLabel="beskrivelse">
            </ng-select>
        </li>
        <li>
            <label class="col-form-label col-form-label-sm" for="sa">Sagsansvarlig</label>
            <ng-select id="sa"
                       name="sa"
                       [disabled]="sag.locked"
                       required
                       class="ng-select-sm"
                       (change)="sagChange({sa: $event?.cardId})"
                       [items]="sagsansvarlige"
                       [ngModel]="sag.sa"
                       placeholder="Vælg Sagsansvarlig"
                       [multiple]="false"
                       [clearable]="true"
                       bindValue="cardId"
                       bindLabel="navn">
            </ng-select>
        </li>
        <li>
            <label class="col-form-label col-form-label-sm" for="medarb">Øvrige medarbejdere</label>
            <ng-select id="medarb"
                       name="medarb"
                       [disabled]="sag.locked"
                       class="ng-select-sm"
                       (remove)="onRemoveUser($event)"
                       (add)="onAddUser($event)"
                       [items]="users"
                       [ngModel]="caseUserIds"
                       placeholder="Vælg medarbejdere"
                       [multiple]="true"
                       [clearable]="false"
                       bindValue="cardId"
                       bindLabel="navn">
            </ng-select>
        </li>
        <li>
            <label class="col-form-label col-form-label-sm" for="fra">Udføres fra</label>
            <app-month-picker id="fra"
                              #fra="ngModel"
                              name="fra"
                              [disabled]="sag.locked"
                              required
                              mask="LL-yy"
                              placeholder="mm-åå"
                              (ngModelChange)="fraChange(fra)"
                              [ngModel]="sag.fra"></app-month-picker>
        </li>
        <li>
            <label class="col-form-label col-form-label-sm" for="til">Udføres til</label>
            <app-month-picker id="til"
                              #til="ngModel"
                              name="til"
                              [disabled]="sag.locked"
                              required
                              mask="LL-yy"
                              placeholder="mm-åå"
                              [lastDayOfMonth]="true"
                              (ngModelChange)="tilChange(til)"
                              [ngModel]="sag.til"></app-month-picker>
        </li>
    </ol>
</form>
